import { useMemo } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';

import { getEntityPageModel, type EntityPageModel } from './entityPageModel';

export const useEntityPageModel = (): EntityPageModel => {
  const { entity } = useEntity();

  return useMemo(() => getEntityPageModel(entity), [entity]);
};
